import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";
import { cardMixin } from "@/widgets/Container/Templates/mixin";

export const ArticuloServiceLayoutContainer = styled.div`

  .banner-container {
    margin-top: 60px;
    margin-bottom: 60px;
  }
`;

export const ParentListBox = styled.div`
  gap: 20px;
  display: grid;
  grid-template-columns: repeat(4, 314px);
  grid-template-rows: repeat(5, 1fr);
  width: max-content;
  grid-template-rows: inherit;
  position: relative;
  margin: 1rem auto;
  .div1 {
    grid-area: 1 / 1 / 6 / 4;
  }
  .div2 {
    grid-area: 1 / 4 / 6 / 5;
    border-left: 1px solid #E0E0E0;
    padding-left: 13px;
    ${breakpoints.phone} {
      padding:0;
      border-left:none;
    }
  }

  ${breakpoints.tablet} {
    grid-template-columns: repeat(3, 314px);
    .div1 {
      grid-area: 1 / 1 / 6 / 3;
    }
    .div2 {
      grid-area: 1 / 3 / 4 / 4;
    }
  }
  ${breakpoints.phone} {
    max-height: inherit;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap:0;
    > div{
      grid-area:auto!important;
      height:auto;
      ul{
        li{
          height:auto!important;
        }
      }
    }
  }

  .div1 ul li {
    &:not(:last-child)::before {
      content: "";
      position: absolute;
      right: -8px;
      top: 0;
      width: 1px;
      height: 94%;
      background-color: ${Color.greySeparator};
      ${breakpoints.phone} {
        display: none;
      }
    }
    &:nth-of-type(3n)::before {
      width: 0;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0px;
      width: calc(100% + 20px);
      height: 1px;
      background-color: ${Color.greySeparator};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color: ${ColorDark.greySeparator};
        }
      }
    }
    &:nth-of-type(3n)::after {
      width: 100%;
    }
    .mt{
      h2.title{
        font-size: 19px;
        line-height: 23px;
      }
      .date {
        display: block !important;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.mainColor};
          }
        }
      }
      .volanta {
        display: none;
      }
    }
  }

  .astrology-today {
    ${Font.sansBold};
    border-radius: 50px;
    width: 90px;
    cursor: pointer;
    font-size: 12px;
    text-align: center;
    text-decoration: none;
    margin: auto;
    margin-top: 40px;
    border: 1px solid ${Color.grey999};
    color: ${Color.grey999};
    line-height: 35px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color: ${ColorDark.textLight};
      border: 1px solid ${ColorDark.textLight};
      }
    }
    ${breakpoints.phone} {
      margin: 20px auto;
    }
  }
`;

export const ListThreeColumns = styled.ul`
  grid-gap: 20px;
  margin:auto;
  width: max-content;
  grid-template-rows: inherit;
  display: grid;
  
  ${breakpoints.desktop} {
    grid-template-columns: repeat(3, 314px);
    gap: 20px;
    margin: 10px auto 40px;
    width: max-content;
    grid-template-rows: inherit;
    display: grid;
    padding-bottom: 0.5rem;
    .div1 { grid-area: 1 / 1 / 3 / 2; }
    .div2 { grid-area: 1 / 2 / 3 / 3; }
    .div3 { grid-area: 1 / 3 / 3 / 4; }
    .div4 { grid-area: 1 / 4 / 3 / 5; }
  }

  ${breakpoints.tablet} {
    grid-template-columns: repeat(2, 314px);
    .div1 { grid-area: 1 / 1 / 3 / 2; }
    .div2 { grid-area: 1 / 2 / 3 / 3; }
    .div3 { grid-area: 1 / 3 / 2 / 4;}
    .div4 { grid-area: 2 / 3 / 3 / 4;}
  }

  ${breakpoints.phone} {
    max-height: inherit;
    display: flex;
    flex-direction: column;
    width: 100% ;
    padding:0 ;

  }
`;

export const Card = styled.li`
  ${cardMixin}

  &:not(:nth-last-child(-n+4))::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0px;
    height: 1px;
    background-color: #E0E0E0;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      background-color: ${ColorDark.darkGrey};
      }
    }
    
    
  }
  &:after {
    left: -21px;
    width: 107%;
    ${breakpoints.phone}{
      width:100%;
    }
  }
  &:last-child::after,
  &:nth-child(4n)::after {
    width: 100%;
  }

  &:nth-child(4n)::before {
    background: transparent;
  }

  &:not(:last-child)::before {
    height:98%; 
  }
  ${breakpoints.tablet} {
    &:not(:nth-last-child(-n+3))::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0px;
      height: 1px;
      background-color: #E0E0E0;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color: ${ColorDark.darkGrey};
        }
      }
    }
    &:nth-child(3n)::before {
      background: transparent;
    }
    &:nth-child(3n)::after {
      width: 100%;
    }
    &:nth-child(4n)::after {
      width: 107%;
      ${breakpoints.phone}{
        width:100%;
      }
    }
    &:nth-child(4n)::before {
      background-color: #E0E0E0;
      ${breakpoints.darkMode} {

        [data-theme='dark'] & {
        background-color: ${ColorDark.darkGrey};
        }
      }
    }
  }

`